// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1swr3","content":"styles_content__ZoiXv","tableWrap":"styles_tableWrap__3pJMk"};